<template>
    <div class="bank">
        <div class="bankUl" v-show="!bankSearch">
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 12">
                <div class="label">持卡企业</div>
                <div class="input">
                    <input type="text" v-model="bankInfo.corporationName" placeholder="请输入持卡企业" readonly>
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 12">
                <div class="label">卡号</div>
                <div class="input">
                    <input type="text" v-model="corporationInfo.basicAcctNo" placeholder="请输入银行卡号">
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" @click="selectBank">
                <div class="label">银行</div>
                <div class="input icon">
                    <input type="text" v-model="bankInfo.bankName" placeholder="请输入银行" readonly>
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 12">
                <div class="label">分支行</div>
                <div class="input">
                    <input type="text" v-model="bankInfo.branchName" placeholder="请输入银行所属支行" >
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 12">
                <div class="label">核准号</div>
                <div class="input">
                    <input type="text" v-model="corporationInfo.approvalNo" placeholder="请输入企业核准号/基本存款账户编号" >
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 11">
                <div class="label">卡类型</div>
                <div class="input">
                    <input type="text" v-model="bankInfo.bankType" readonly>
                </div>
            </div>
            <div class="itemLi borderBot borderBotLeft0" v-show="userType * 1 === 11">
                <div class="label">手机号</div>
                <div class="input">
                    <input type="tel" placeholder="请输入银行预留手机号" maxlength="11" v-model="bankInfo.bankPhoneNumber">
                </div>
            </div>
        </div>
        <div class="bankSearch" v-show="bankSearch">
            <div class="search">
                <div class="input">
                    <form action="/">
                        <van-search
                            v-model="searchBankName"
                            placeholder="请输入银行名称"
                            use-action-slot
                            @search="searchBank"
                        />
                        <div class="btn btnSearch" @click="searchBank">搜索</div>
                        <div class="btn" @click="bankshow">取消</div>
                    </form>
                </div>
            </div>
            <div class="nav">如果没有您所选的银行，请电话联系4008280280</div>
            <div class="banklist">
                <van-cell  v-for="item in bankSearchList" :key="item.bankCode" :value="item.bankName" @click="cellClick(item)" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
export default {
    props: {
        bankInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        corporationInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        userType: {
            type: Number,
            default: 11
        }
    },
    computed: {
        ...mapGetters(['bankSearchListData'])
    },
    data () {
        return {
            bankSearchList: [],
            searchBankName: '',
            bankSearch: false
        }
    },
    methods: {
        selectBank () {
            this.bankSearch = true
            this.backBank()
        },
        bankshow () {
            this.bankSearch = false
            this.backBank()
        },
        backBank () {
            this.bankSearchList = []
            this.searchBankName = ''
            this.$emit('bankSearch', this.bankSearch)
        },
        cellClick (item) {
            this.bankSearch = false
            this.$emit('bankClick', item)
        },
        async searchBank () {
            if (!this.searchBankName) {
                Toast('请输入银行卡名称')
                return
            }
            await this.$store.dispatch('getBankSearchListAct', { bankName: this.searchBankName })
            this.bankSearchList = this.bankSearchListData
        }
    }
}
</script>

<style lang="scss" scoped>
.bank {
    .bankUl{
        position: relative;
        font-size: 28px;
        color: #000000;
        font-weight:400;
        .itemLi{
            position: relative;
            display: flex;
            justify-content: flex-start;
            background: #ffffff;
            padding: 32px 32px 32px 0;
            height: 40px;
            line-height: 40px;
            .label{
                flex: 0 0 152px;
            }
            .input{
                flex: 1;
            }
            .icon:after{
                content: '';
                position: absolute;
                right: 24px;
                top: 32px;
                width: 40px;
                height: 40px;
                background: url('../../../../assets/img/b2b/icon_detail.png') no-repeat;
                background-size: 100% 100%;
            }
            span{
                display: inline-block;
                position: absolute;
                right: 32px;
                top: 38px;
                width: 30px;
                height: 30px;
                background: url('../../../../assets/img/b2b/icon-delete.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .search {
        padding:0 24px 0 0;
        z-index: 999;
        background:#fff;
        display: flex;
        justify-content: space-between;
        .input {
            position: relative;
            width: 100%;
            &:before {
                content: "";
                position: absolute;
                left: 25px;
                top: 40px;
                width: 40px;
                height: 40px;
                background: url('../../../../assets/img/b2b/search.png') no-repeat;
                background-size: 100% 100%;
            }
            span{
                display: inline-block;
                position: absolute;
                right: 25px;
                top: 25px;
                width: 30px;
                height: 30px;
                background: url('../../../../assets/img/b2b/icon-delete.png') no-repeat;
                background-size: 100% 100%;
            }
            form{
                display: flex;
                align-items: center;
                .van-search{
                    flex: 1;
                }
                .btn{
                    color: #FF7A45;
                    flex: 0 0 100px;
                    text-align: center;
                    &.btnSearch{
                        color: #ffffff;
                        background: #FF7A45;
                        height: 50px;
                        line-height: 50px;
                        border-radius: 50px;
                    }
                }
            }
        }
        input {
            height: 80px;
            line-height: 80px;
            border-radius: 200px;
            padding-left: 74px;
            padding-right: 60px;
            font-size: 28px;
            color: #C7C7C7;
            box-sizing: border-box;
            background:#F0F0F0;
        }
        i{
            line-height: 80px;
            text-align: center;
            font-size: 28px;
            color:#FF7A45
        }
    }
    .nav{
        font-size: 26px;
        color: #8E8E93;
        font-weight: 400;
        padding: 22px 32px 22px 0;
    }
}
/deep/ .van-search {
    padding: 20px 0;
    font-size: 28px;
    .van-search__content{
        padding-left: 0;
        height: 80px;
        line-height: 80px;
        border-radius: 80px;
        background: #EBEBEB;
        margin-right: 20px;
        .van-cell{
            padding: 0;
            font-size: 28px;
        }
        .van-cell__value--alone{
            height: 80px;
            line-height: 80px;
            display: flex;
        }
        .van-field__left-icon{
            margin-right: 20px;
            padding-left: 24px;
            .van-icon{
                font-size: 40px;
            }
        }
    }
    .van-search__action{
        color: #FF7A45;
        font-size: 28px;
    }
    .van-icon-search:before{
        display: none;
    }
}
</style>